import { useEffect, useState } from "react";
import { useQuery } from "react-query";

import { getDocumentBlob } from "../api/pickupRequests";

// jsdom (the test environment) has no URL.createObjectURL - guarding it keeps every consumer
// of this hook safe to render in tests without a browser-API mock, falling back to the
// no-thumbnail state instead of throwing.
const canCreateObjectUrl = () => typeof URL.createObjectURL === "function";

const useDocumentImageUrl = (path: string | null): string | null => {
  const { data: blob } = useQuery(
    ["pickupRequestDocumentBlob", path],
    () => getDocumentBlob(path!),
    { enabled: !!path, staleTime: Infinity }
  );

  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!blob || !canCreateObjectUrl()) {
      setUrl(null);
      return undefined;
    }

    const objectUrl = URL.createObjectURL(blob);

    setUrl(objectUrl);

    return () => URL.revokeObjectURL(objectUrl);
  }, [blob]);

  return url;
};

export default useDocumentImageUrl;
